import { datadogRum } from '@datadog/browser-rum';

import {
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_ENV,
  PACKAGE_JSON_VERSION,
} from '../constants';

const defaultConfig = {
  applicationId: DATADOG_APPLICATION_ID,
  clientToken: DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'tcr-csp-portal',
  env: DATADOG_ENV,
  allowedTracingUrls: [
    /^https:\/\/csp-[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.campaignregistry\.com(?::\d+)?(?:[\/?#].*)?$/,
    /^https:\/\/csp\.campaignregistry\.com(?::\d+)?(?:[\/?#].*)?$/,
  ],
  version: PACKAGE_JSON_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  startSessionReplayRecordingManually: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackViewsManually: true,
  defaultPrivacyLevel: 'mask-user-input',
};

const datadog = {
  init: async (customConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...customConfig,
    };
    !datadogRum.getInitConfiguration() && datadogRum.init(config);
  },
  setUser: (userInfo) => {
    const config = {
      id: userInfo.cspUid,
      name: userInfo.name,
      email: userInfo.email,
      userId: userInfo.sub,
      authUid: userInfo.cspUid,
    };
    datadogRum.setUser(config);
    // Disable session replay recording for now
    // datadogRum.startSessionReplayRecording();
  },
  hasUser: () => {
    const user = datadogRum.getUser();
    if (user && user.id) {
      return true;
    }
    return false;
  },
  addError: (error) => {
    datadogRum.addError(error);
  },
  addAction: (name, context) => {
    datadogRum.addAction(name, context);
  },
};

export default datadog;
